import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";

@Component({
    selector: "metadata-html",
    templateUrl: "./metadataHtml.tmpl.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MetadataHtmlComponent
{
    @Input() model: string;

    get value(): string
    {
        return !Utilities.IsNullOrUndefinedOrEmpty(this.model) ? this.model : "";
    }
}
